import { useContext } from 'react';
import { useMemo } from 'react';
import { CustomVizContext } from 'apps/sigma2-ui/src/components/custom-viz/CustomVizContext';
import { CustomVizHook } from 'apps/sigma2-ui/src/components/custom-viz/hooks/custom-viz-hook';

export const useCustomViz = (): CustomVizHook => {
  const context = useContext(CustomVizContext);

  const {
    doViz,
    result,
    resultCreatedAt,
    staleResult,
    staleResultCreatedAt,
    status,
    dropdownOptions,
    lastSuccessfulCustomVizRequest,
    currentInProgressCustomVizRequest,
    cancelViz,
    hasCurrentCustomVizPolledMultipleTimes,
  } = context;

  return useMemo(() => {
    return {
      doViz,
      result,
      resultCreatedAt,
      staleResult,
      staleResultCreatedAt,
      status,
      dropdownOptions,
      lastSuccessfulCustomVizRequest,
      currentInProgressCustomVizRequest,
      cancelViz,
      hasCurrentCustomVizPolledMultipleTimes,
    };
  }, [
    doViz,
    result,
    resultCreatedAt,
    staleResult,
    staleResultCreatedAt,
    status,
    dropdownOptions,
    lastSuccessfulCustomVizRequest,
    currentInProgressCustomVizRequest,
    cancelViz,
    hasCurrentCustomVizPolledMultipleTimes,
  ]);
};
